var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fm-notification"},[_c('transition-group',{attrs:{"name":"notify"}},_vm._l((_vm.notifications),function(notification,index){return _c('div',{key:`notify-${index}`,staticClass:"fm-notification-item",class:`fm-${notification.status}`,attrs:{"role":"alert"}},[_vm._v("\n      "+_vm._s(notification.message)+"\n    ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }